/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SaveOrgAuthRequest { 
    id?: number;
    enabled: boolean;
    organizationId: number;
    login: string;
    password: string;
    token?: string;
    tokenDate?: string;
}

